const shopifyGET = (url) => fetch(url, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
}).then((resp) => resp.json());
const shopifyPOST = (url, body) => fetch(url, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
}).then((resp) => resp.json());
// Get product information by its search engine friendly handle - returns Promise
export const getProductByHandle = (handle) => shopifyGET(`/products/${handle}.js`);
// Get current cart
export const getCart = () => shopifyGET('/cart.js');
// Updates single item in current cart. Can be used for adding as well.
export const updateItemInCart = (id, quantity) => shopifyPOST('/cart/update.js', {
    updates: {
        [id]: quantity,
    },
});
// Format image url with size attribute
export const appendSizeToFilename = (url, size = '', regex = /^\/(?<path>.+?)\.(?<ext>jpeg|jpg|pjpg|gif|webp|png)$/i) => {
    const withProtocol = url.startsWith('//') ? `https:${url}` : url;
    const parsed = new URL(withProtocol);
    const match = parsed.pathname.match(regex);
    if (!match || !match.groups) {
        throw new Error('Invalid pathname');
    }
    parsed.pathname = `${match.groups['path']}${size ? '_' + size : ''}.${match.groups['ext']}`;
    return parsed.toString();
};
export const resizeShopifyImage = (url) => url.includes('300x300') ? url : appendSizeToFilename(url, '300x300');
